import { useState, useEffect } from 'react';
import useSWR from 'swr';

import { IRepository } from '@/types';
import { fetchResourceDefiniton, IResourceDefinition } from '@/lib/repositoryBranchesApi';
// import { FOCUS_THROTTLE_INTERVAL } from '@/config/appSettings';
// import { URLSearchParams } from 'url';

interface useResourceDefinitionParams {
  repository: IRepository;
  filePath: string[];
}

const useResourceDefinition = ({ repository, filePath }: useResourceDefinitionParams): IResourceDefinition => {
  const [resource, setResource] = useState<IResourceDefinition | undefined>();
  const fetchKey = ['resourceDefinition', repository.namespace, repository.name, filePath];

  const { data, isLoading, isValidating } = useSWR(fetchKey, () => fetchResourceDefiniton(repository, filePath), {
    keepPreviousData: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  useEffect(() => {
    if (data) {
      setResource(data);
    }
  }, [data]);

  return resource as IResourceDefinition;
};

export default useResourceDefinition;
